export default {"src":"/_next/static/media/AU.b72b1122.svg","height":20,"width":29};